const postsSliderInit = (block) => {
    const sliders = block ? [block[0].querySelector(".bn-blog-posts .swiper")] : Array.from(document.querySelectorAll('.bn-blog-posts .swiper'));

    if (sliders) {
        sliders.forEach((slider) => {
            if (slider) {
                const sliderConfig = {
                    observer: true,
                    observeSlideChildren: true,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                    },
                    slidesPerView: 1,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                    allowTouchMove: slider.dataset.allowtouchmove === "0",
                    navigation: {
                        nextEl: slider.parentNode.querySelector(".swiper-button-next"),
                        prevEl: slider.parentNode.querySelector(".swiper-button-prev"),
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 10,
                        },
                        1600: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                        }
                    }
                }

                let currentSlider = new Swiper(slider, sliderConfig);
                currentSlider.on( 'observerUpdate', () => {
                    currentSlider.destroy(currentSlider, true);
                    currentSlider = new Swiper(slider, sliderConfig);
                });
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        postsSliderInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/blog-posts', postsSliderInit);
});